import { API_HEADERS } from '../constants/apiHeaders';
import api from '../utils/api';
import { SYSTEM_ENDPOINTS } from './endpoints/system.endpoints';
import type { DesignationOption, DropdownOption } from './types/userProfile.types';

type ListEnvelope<T> = { data: T; count: number };

export const systemService = {
  getGenders: () =>
    api.get<ListEnvelope<DropdownOption[]>>(SYSTEM_ENDPOINTS.genders, {
      headers: API_HEADERS.USER_PROFILE_GENDERS,
    }),

  getDepartments: () =>
    api.get<ListEnvelope<DropdownOption[]>>(SYSTEM_ENDPOINTS.departments, {
      headers: API_HEADERS.USER_PROFILE_DEPARTMENTS,
    }),

  getDesignations: () =>
    api.get<ListEnvelope<DesignationOption[]>>(SYSTEM_ENDPOINTS.designations, {
      headers: API_HEADERS.USER_PROFILE_DESIGNATIONS,
    }),
};
